import { useMutation } from '@tanstack/react-query';

import { analyticServices } from '@hero/services';

export const useOrderReport = options => {
  return useMutation(body => analyticServices.getOrderReport(body), {
    ...options
  });
};
